import { Component, OnInit } from '@angular/core';
import { AuthorisedSideNavService } from '../../../layout/authorised/services/authorised-side-nav.service';
import { FormBuilder,FormControl, Validators ,FormGroup,FormArray } from '@angular/forms';
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import { ClientServiceService } from "../../../shared/client-service.service";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {
  loggeduser: any;
  orderData: any[] = [];
  verify_code='';
  orderDetails:any;
  creation_date='';
  order_number='';
  seo_consultant='';
  seo_consultant_email='';
  total_monthly:number=0;
  total_yearly:number=0;
  total_grand:number=0;
  is_order_submitted=false;
  is_sign_submitted=false;
  is_order_loading=false;
  is_order_responded=false;
  is_order_responded_success=false;
  is_order_responded_failed=false;
  customerForm = new FormGroup({
    name: new FormControl('', Validators.required),
    company_name: new FormControl('', Validators.required),
    billing_address: new FormControl(''),
    billing_city: new FormControl(''),
    state: new FormControl(''),
    country: new FormControl(''),
    zipcode: new FormControl(''),
    telephone: new FormControl('',  [
      Validators.required,
      Validators.minLength(10)
      ]),
    email: new FormControl('',  [
      Validators.required
      ]),
    url: new FormControl('', Validators.required),
  });
  
  items: FormArray;
  signForm: FormGroup;
  payment_form_init=false;
  is_payment_submitted=false;
  payment_mode_ids=0;
  paymentForm: FormGroup;
  constructor(public sideNavService: AuthorisedSideNavService,private formBuilder: FormBuilder,public restApi: ClientServiceService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.signForm = new FormGroup({
      el_seg: new FormControl(false, Validators.requiredTrue),
      service_agg: new FormControl(false, Validators.requiredTrue),
      signature: new FormControl('', Validators.required),
      title: new FormControl('', Validators.required)
    });
    this.route.paramMap.subscribe(params => {
      console.log("order id:");
      this.verify_code=params.get('id');
      
      this.restApi.getOrderDetails(this.verify_code).subscribe(data =>{
        if(data.found=="true")
        {
          this.orderDetails=data;
          console.log(this.orderDetails);
          this.updateform(this.orderDetails.orderrow);
          this.init_payment_form();

        }
      })
      
    });

  }
  
  signsubmit()
  {

    this.is_sign_submitted=true;
    if (this.customerForm.valid && this.paymentForm.valid && this.signForm.valid) 
    {
      this.is_order_loading=true;
      var self=this;
      this.restApi.SubmitSignForm(this.customerForm.value,this.paymentForm.value,this.signForm.value,this.verify_code).subscribe(data =>{
        console.log(data);
        self.is_order_responded=true;
        self.is_order_responded_success=true;
        self.is_order_loading=false;
        
        document.querySelector('.breadcrumb').scrollIntoView({ behavior: 'smooth', block: 'center' });
		 window.location.href = "/thankyou";
      })
    }
  }
  
  init_payment_form()
  {
    this.payment_mode_ids=this.orderDetails.orderrow.payment_mode_ids;
    if(this.orderDetails.orderrow.payment_mode_ids==2)
    {
      this.paymentForm = new FormGroup({
        credit_card_type: new FormControl('', Validators.required),
        card_name: new FormControl('', Validators.required),
        credit_card_no: new FormControl('', Validators.required),
        month: new FormControl('', Validators.required),
        year: new FormControl('', Validators.required),
        credit_card_security_code: new FormControl('', Validators.required),
        crd_street_address: new FormControl('', Validators.required),
        credit_card_zip_code: new FormControl('', Validators.required)
      });
    }
    if(this.orderDetails.orderrow.payment_mode_ids==1)
    {
      this.paymentForm = new FormGroup({
        cheque_no: new FormControl('', Validators.required)
      });
    }
    if(this.orderDetails.orderrow.payment_mode_ids==3)
    {
      this.paymentForm = new FormGroup({
        wire_transfer_id: new FormControl('', Validators.required)
      });
    }
    if(this.orderDetails.orderrow.payment_mode_ids==4)
    {
      this.paymentForm = new FormGroup({
        paypalId: new FormControl('', Validators.required)
      });
    }
    if(this.orderDetails.orderrow.payment_mode_ids==5)
    {
      this.paymentForm = new FormGroup({
        echeque_no: new FormControl('', Validators.required)
      });
    }
    this.payment_form_init=true;
  }
  updateform(orderDetails)
  {
    this.customerForm.controls['name'].setValue(orderDetails.name);
    this.customerForm.controls['company_name'].setValue(orderDetails.company_name);
    this.customerForm.controls['billing_address'].setValue(orderDetails.billing_address);
    this.customerForm.controls['billing_city'].setValue(orderDetails.billing_city);
    this.customerForm.controls['state'].setValue(orderDetails.state);
    this.customerForm.controls['country'].setValue(orderDetails.country);
    this.customerForm.controls['zipcode'].setValue(orderDetails.zipcode);
    this.customerForm.controls['email'].setValue(orderDetails.email);
    this.customerForm.controls['url'].setValue(orderDetails.url);
    this.customerForm.controls['telephone'].setValue(orderDetails.telephone);
    this.creation_date=orderDetails.date;
    this.order_number=orderDetails.order_number;
    this.seo_consultant=orderDetails.seo_consultant;
    this.seo_consultant_email=orderDetails.seo_consultant_email;
    
  }
  
  

}